export const accountTypes = [
  {
    icon: "🏢",
    name: "Conta Corrente",
  },
  {
    icon: "💰",
    name: "Conta Poupança",
  },
  {
    icon: "💵",
    name: "Carteira",
  },
  {
    icon: "🪙",
    name: "Outro",
  },
];

export const IncomeCategories = [
  {
    icon: "💵",
    name: "Salário",
  },
  {
    icon: "🪙",
    name: "Benefício",
  },
  {
    icon: "💸",
    name: "Transferência",
  },
  {
    icon: "💰",
    name: "Outro",
  },
];

export const ExpanseCategories = [
  {
    icon: "🏠",
    name: "Casa",
  },
  {
    icon: "🍔",
    name: "Alimentação",
  },
  {
    icon: "💵",
    name: "Transferência",
  },
  {
    icon: "🚌",
    name: "Transporte",
  },
  {
    icon: "📚",
    name: "Educação",
  },
  {
    icon: "🎭",
    name: "Lazer",
  },
  {
    icon: "📞",
    name: "Comunicação",
  },
  {
    icon: "💊",
    name: "Saúde",
  },
  {
    icon: "💰",
    name: "Outro",
  },
];

export const ColorsList = [
  {
    id: 1,
    color: "#cc092f",
  },
  {
    id: 2,
    color: "#ec0000",
  },
  {
    id: 3,
    color: "#70cfff",
  },
  {
    id: 4,
    color: "#b8cad4",
  },
  {
    id: 5,
    color: "#003B70",
  },
  {
    id: 6,
    color: "#716842",
  },
  {
    id: 7,
    color: "#F9DD16",
  },
  {
    id: 8,
    color: "#0038A8",
  },
  {
    id: 9,
    color: "#FF8C00",
  },
  {
    id: 10,
    color: "#612F74",
  },
  {
    id: 11,
    color: "#77dd77",
  },
  {
    id: 12,
    color: "#22c25f",
  },
  {
    id: 13,
    color: "#FF7200",
  },
  {
    id: 14,
    color: "#2673CE",
  },
];
